/**
 * 에러 참고 문서: https://docs.google.com/spreadsheets/d/1pGaW1f__ZiwEy-0xpBAmZsECTS8cgKRnFCGpp5cA09o/edit#gid=1922310484
 */
export enum ApiStatusCodeVo {
  // 성공
  Success = 0,
  // 유효하지 않은 주문입니다.
  InvalidOrder = -100,
  // 인증 티켓이 유효하지 않습니다.
  InvalidAuthTicket = -101,
  // 이벤트 티켓이 유효하지 않습니다.
  InvalidEventTicket = -102,
  // 이벤트 기간이 아닙니다.
  NotEventPeriod = -103,
  // VOD 이벤트 설정이 유효하지 않습니다.
  InvalidVodEventSetting = -104,
  // 필수 파라미터가 존재하지 않습니다.
  NotExistRequiredParam = -105,
  // 결제 데이터가 잘못 되었습니다.
  InvalidPaymentData = -106,
  // VOD만 지원합니다.
  OnlySupportVod = -107,
  // 아이템이 유효하지 않습니다.
  InvalidItem = -108,
  // 아이템 코드가 존재하지 않습니다.
  NotExistItemCode = -109,
  // 중복된 아이템 코드가 존재합니다.
  DuplicateItemCode = -110,
  // 이벤트 금액이 유효하지 않습니다.
  InvalidEventAmount = -113,
  // 본인 인증을 하지 않은 사용자입니다.
  NotCertifiedUser = -114,
  // 월 한도 충전 금액을 초과하였습니다.
  ExceedMonthlyLimitAmount = -115,
  // 총 보유 캐시를 초과하였습니다.
  ExceedTotalCash = -116,
  // 비정상 유저입니다.
  AbnormalUser = -117,
  // 이벤트 지급 기간 설정에 오류가 있습니다.
  InvalidEventPeriodSetting = -118,
  // 단건 결제 가격이 다릅니다.
  NotEqualSinglePaymentAmount = -119,
  // 총 아이템 금액이 일치하지 않습니다.
  NotEqualTotalItemAmount = -120,
  // 총 아이템 개수가 일치하지 않습니다.
  NotEqualTotalItemCount = -121,
  // 미성년자 월 한도 충전 금액을 초과하였습니다.
  ExceedMinorMonthlyLimitAmount = -122,
  // 사용 중인 이벤트가 아닙니다.
  NotUsingEvent = -123,
  // 종료 날짜가 시작 날짜보다 전입니다.
  EndDateBeforeStartDate = -124,
  // 서버내 처리에 실패하였습니다.
  FailServerProcess = -125,
  // 서버내 처리에 실패하였습니다.
  FailServerProcess2 = -126,
  // 유효하지 않은 쿠폰입니다.
  InvalidCoupon = -127,
  // 현금 영수증 정보가 유효하지 않습니다.
  InvalidCashReceiptInfo = -128,
  // 이벤트 만료일이 오늘보다 이전입니다.
  ExpiredEvent = -129,
  // 은행 계좌 정보가 유효하지 않습니다.
  InvalidBankAccountInfo = -137,
  // 은행 계좌 소유자의 이름(은행API의 전달값)과 사용자의 이름이 일치하지 않음
  NotEqualBankAccountOwnerName = -139,

  // 유저 정보가 일치하지 않습니다.
  NotEqualUserInfo = -200,
  // 취소 금액이 일치하지 않습니다.
  NotEqualCancelAmount = -201,
  // 결제 정보가 일치하지 않습니다.
  NotEqualPaymentInfo = -202,
  // 이벤트 설정 금액과 증여 금액이 다릅니다.
  NotEqualEventSettingAmountAndGiftAmount = -203,
  // 이벤트 설정 금액보다 증여 금액이 큽니다.
  EventSettingAmountLessThanGiftAmount = -204,
  // 등록 상품 가격과 일치하지 않습니다.
  NotEqualRegisteredItemPrice = -205,
  // 이벤트 설정 금액이 기존 이벤트 금액보다 큽니다.
  EventSettingAmountGreaterThanOldEventAmount = -206,
  // 구매 금액보다 취소 금액이 큽니다.
  PurchaseAmountLessThanCancelAmount = -207,
  // iOS 영수증 파싱에 실패하였습니다.
  FailParseIosReceipt = -208,
  // 서버내 처리에 실패하였습니다.
  FailServerProcess3 = -209,
  // 카카오페이지에서 사용할 수 없는 쿠폰입니다.
  NotSupportCoupon = -210,
  // 서버내 처리에 실패하였습니다.
  FailServerProcess4 = -211,

  // 이미 취소한 소진 이력입니다.
  AlreadyCanceledCashConsumptionHistory = -300,
  // 잔액이 부족합니다.
  NotEnoughBalance = -301,
  // 이벤트 금액이 부족합니다.
  NotEnoughEventAmount = -302,
  // 이미 지급한 이벤트입니다.
  AlreadyGiftedEvent = -303,
  // 사용 완료 상태가 아닙니다.
  NotCompleteStatus = -304,
  // 결제 요청 상태가 아닙니다.
  NotPaymentRequestStatus = -305,
  // 이벤트 업데이트에 실패하였습니다.
  FailUpdateEvent = -306,
  // 결제 요청 상태가 아닙니다.
  NotPaymentRequestStatus2 = -307,
  // 환불 가능한 캐시가 존재하지 않아 환불에 실패하였습니다.
  NotExistRefundableCash = -308,
  // 결제 취소된 쿠폰입니다.
  CancelledCoupon = -309,
  // 동일한 코드로 이미 지급 받았습니다.
  AlreadyGiftedSameCode = -310,
  // 사용 만료된 쿠폰입니다.
  ExpiredCoupon = -311,

  // 존재하지 않는 유저입니다.
  NotExistUser = -400,
  // 캐시 소진 이력이 존재하지 않습니다.
  NotExistCashConsumptionHistory = -401,
  // 구매 아이템이 존재하지 않습니다.
  NotExistPurchaseItem = -402,
  // 아이템이 존재하지 않습니다.
  NotExistItem = -403,
  // 이벤트를 찾을 수 없습니다.
  NotExistEvent = -404,
  // 결제 수단이 존재하지 않습니다.
  NotExistPaymentMethod = -405,
  // 캐시 정보가 존재하지 않습니다.
  NotExistCashInfo = -406,
  // 유효하지 않는 쿠폰입니다.
  InvalidCoupon2 = -407,
  // 거래 내역이 존재하지 않습니다.
  NotExistTransactionHistory = -408,

  // 알 수 없는 문제가 발생하였습니다.
  UnknownProblemError = -500,
  // 데이터 파싱에 실패하였습니다.
  FailParseData = -501,
  // 이벤트 지급에 실패하였습니다.
  FailGiftEvent = -502,
  // 웹 결제 아이템 지급에 실패하였습니다.
  FailGiftWebPaymentItem = -503,
  // 본인 인증에 실패하였습니다.
  FailVerifyIdentity = -504,
  // 탈퇴에 실패하였습니다.
  FailWithdraw = -505,
  // 이용권 소진 취소에 실패했습니다.
  FailCancelTicketConsumption = -506,
  // 이벤트 생성에 실패하였습니다.
  FailCreateEvent = -507,
  // 데이터 생성에 실패하였습니다.
  FailCreateData = -508,
  // 데이터 수정에 실패하였습니다.
  FailUpdateData = -509,
  // 서버내 처리에 실패하였습니다.
  FailServerProcess5 = -510,
  // 서버내 처리에 실패하였습니다.
  FailServerProcess6 = -511,
  // 최신 버전으로 업데이트 필요합니다.
  NeedUpdate = -517,

  // 환불 가능한 잔액이 존재하지 않음
  NotExistRefundableBalance = -1201,
  // 환불 가능한 캐시가 존재하지 않음 (요청 금액 > 실제 요청 금액)
  RequestAmountExceedsAvailableAmount = -1205,
  // 환불 요청 금액이 실제 환불 가능 금액과 일치하지 않습니다
  RequestAmountNotMatched = -1211,
  // 이전 환불 요청이 진행중입니다.
  RequestAlreadyInProgress = -1212,
}
